import { Can } from 'providers/casl'

export const onLayoutAccess = (can: Can) => {
  can('access', 'Layout')
}
